import { render } from "./ModalAddEditCategory.vue?vue&type=template&id=383ed660"
import script from "./ModalAddEditCategory.vue?vue&type=script&lang=js"
export * from "./ModalAddEditCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__